import { Popup, TWclassNames } from "./Div";
import { style } from "motion";
import { Link } from "react-router-dom";

export const PMButton = ({ styleType = "primary", ...props }: any) => {
  const { children, onClick, type, className, tooltip, to, target, disabled, loading } =
    props;

  function styleTypeClass() {
    const baseClasses = disabled 
      ? "opacity-50 cursor-not-allowed" 
      : "cursor-pointer";
    
    switch (styleType) {
      case "primary":
        return `bg-blue-400 hover:bg-indigo-700 rounded-md border border-transparent bg-blue-400 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${baseClasses}`;
      case "minimal":
        return `bg-transparent hover:text-blue-400 text-xs ${baseClasses}`;
      case "custom":
        return baseClasses;
      default:
        return baseClasses;
    }
  }

  if (type === "button") {
    return (
      <Popup content={tooltip} textSize="md">
        <button
          onClick={disabled ? undefined : onClick}
          type="button"
          disabled={disabled}
          className={TWclassNames(
            "flex w-full justify-center",
            className,
            styleTypeClass()
          )}
        >
          {loading ? (
            <div className="flex items-center">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              {children}
            </div>
          ) : (
            children
          )}
        </button>
      </Popup>
    );
  } else if (type === "submit") {
    return (
      <Popup content={tooltip} textSize="md">
        <button
          type="submit"
          disabled={disabled}
          className={TWclassNames(
            "flex w-full justify-center",
            className,
            styleTypeClass()
          )}
        >
          {loading ? (
            <div className="flex items-center">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              {children}
            </div>
          ) : (
            children
          )}
        </button>
      </Popup>
    );
  } else if (to) {
    return (
      <Popup content={tooltip} textSize="md">
        <Link
          target={target}
          to={disabled ? "#" : to}
          className={TWclassNames(
            "flex w-full justify-center",
            styleTypeClass(),
            className
          )}
        >
          {children}
        </Link>
      </Popup>
    );
  } else {
    return (
      <Popup content={tooltip} textSize="md">
        <div
          onClick={disabled ? undefined : onClick}
          className={TWclassNames(
            styleTypeClass(),
            "flex w-full justify-center",
            className
          )}
        >
          {children}
        </div>
      </Popup>
    );
  }
};
